import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router'

import * as R from 'ramda'

import MenuItem from 'material-ui/MenuItem';

import Combobox from 'components/Combobox'

import dataActions from 'actions/dataActions'

import { doc, dirtyRead } from 'selectors/common'
import { tenants, properties } from 'selectors/entities'
import { tenantsProperty } from 'selectors/tenant'
import { transactionEx } from 'selectors/transactions'

import { sortSev } from 'utils/stuff'

let select = dirtyRead(
	(state, props) => ({
		object: transactionEx(state, props.objectID)
	  , tenants: tenants(state)
	  , properties: properties(state)
	  , tenantsProperty: tenantsProperty(state)
	})
)

const cats = [
	{name: "Rent", req: "#Income:Rent"},
	{name: "Deposit", req: "#Income:Deposit"},
	{name: "Fee", req: "#Income:Fee"},
	{name: "Expenses", req: "#Income:Expenses"}
]

export class TenantCombobox extends Component{
	render(){
		let { props } = this
		return(
			<Combobox
				icon={
					props.object.partyID?<img
						src={".." + "/static/img/svg-icon/tenants_green.svg"}
						className="left-navigation-icons"
						style={{
							height: "15px"
						  , position: "relative"
						  , top: "2px"
						  , display: ""
						}}
					/>
					:<i
						className="material-icons"
						style={{
							float: "left"
							, width: "21px"
							, position: "relative"
							, top: "-5px"
							, left: "-3px"
							, color: "orange"
						}}
					>
						arrow_forward
					</i>
				}
				link={`/manager/tenant/${props.object.partyID}/`}
				text={(props.object && props.object.partyID && props.tenants[props.object.partyID])? props.tenants[props.object.partyID].tenant?props.tenants[props.object.partyID].tenant:(props.tenants[props.object.partyID].firstName+ " "+ props.tenants[props.object.partyID].lastName): ''}
				hintText={<span>Enter tenant name</span>}
				noDelete={props.object.qbid || (props.object.type=="transaction/invoice-payment" && props.object.partyID)}
				dataSource={
					R.map(tenant => ({
						text: `${tenant.tenant || (tenant.firstName + " " + tenant.lastName)}`
					  , value: (
							<MenuItem
								key={tenant._id}
								primaryText={tenant.tenant || (tenant.firstName + " " + tenant.lastName)}
							/>
						)
					  , id: tenant._id
				  }), sortSev(props.tenants, "tenant", "firstName"))
				}
				onChange={(party)=> {
					let partyObj = party && props.tenants[party.id]
					let newExps = []
					if (party){
						let bkid = '1'//props.properties[partyObj.propertyID] ? props.properties[partyObj.propertyID].ownerID : ""
							let tenantsCategory = partyObj && partyObj.category && partyObj.category[0] || "Rent"
							let i = R.findIndex(R.propEq('name', tenantsCategory))(cats)
							let newEl = {
							  category: tenantsCategory,
							  categoryName: "",
							  amount: "",
							  memo: "",
							}
							newExps = props.object.lines && props.object.lines.length ?
								props.object.lines
								:[newEl]
						}
						//debugger
						props.STAGE({
						_id: props.objectID
					  , partyID: party && party.id
					  , party: party && partyObj? (partyObj.tenant)?partyObj.tenant:partyObj.firstName+' '+partyObj.lastName:""
					  , memo: party && partyObj? partyObj.accountNumber ? "acct# " + partyObj.accountNumber : partyObj.memo ? partyObj.memo : '' : ''
					  , lines: party && (newExps.length ? newExps : [])
					  , propertyID: party && props.tenantsProperty[party.id] && props.tenantsProperty[party.id].propertyID
					})
				}}
			/>
		)
	}
}

export default connect(select, dataActions)(TenantCombobox)



// WEBPACK FOOTER //
// ./src/routes/manager/transactionForm/TenantCombobox.js